/**
 * Portfolio v6 Design Tokens
 *
 * All color, shadow, and spacing tokens for the portfolio.
 */

export const T = {
  teal: '#3DABA5',
  tealDark: '#2D8B86',
  tealBg: 'rgba(61,171,165,0.08)',
  tealBg12: 'rgba(61,171,165,0.12)',
  tealBg20: 'rgba(61,171,165,0.20)',
  coral: '#E07A3D',
  coralBg: 'rgba(224,122,61,0.08)',
  coralBg15: 'rgba(224,122,61,0.15)',
  gold: '#C69026',
  goldBg: 'rgba(198,144,38,0.08)',
  goldBg15: 'rgba(198,144,38,0.15)',
  grey: '#8E8B87',
  greyBg: 'rgba(142,139,135,0.08)',
  greyBg15: 'rgba(142,139,135,0.15)',
  red: '#C4553A',
  cream: '#FAF8F3',
  white: '#FFFFFF',
  text: '#1A1A1A',
  textSec: '#7A7672',
  textMut: '#A8A5A0',
  border: 'rgba(0,0,0,0.04)',
  border03: 'rgba(0,0,0,0.03)',
  div1: '#F0EDE6',
  div2: '#E8E5DE',
  shadow: '0 1px 3px rgba(0,0,0,0.04), 0 1px 2px rgba(0,0,0,0.02)',
  shadowLift: '0 4px 12px rgba(0,0,0,0.06), 0 1px 3px rgba(0,0,0,0.04)',
  green: '#4CAF7A',
  greenBg: 'rgba(76,175,122,0.08)',
  amber: '#D4A017',
  scoreBg: 'rgba(61,171,165,0.04)',
} as const;
